import Vue from "vue";
import Vuex from "vuex";
import persistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    leftbar: {
      drawer: false
    },
    token: "",
    user: {
      islogin: false,
      auth: 0,

      userinfo: {},
      blackInfo: {}
    }
  },
  mutations: {
    toggleLeftBar(state, bool) {
      state.leftbar.drawer = bool;
    },
    userLogin(state, info) {
      state.user.islogin = true;
      state.user.userinfo = info;
      state.user.auth = info.state;
    },
    userLoginOut(state) {
      state.user.islogin = false;
      state.user.userinfo = {};
      state.user.auth = 0;
    },
    saveToken(state, token) {
      state.token = token;
    }
  },
  actions: {},
  modules: {},
  plugins: [persistedState()]
});